import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var ThumbsDown = createReactComponent("ThumbsDown", ["svg", defaultAttributes, [["path", {
  d: "M10 15v4a3 3 0 003 3l4-9V2H5.72a2 2 0 00-2 1.7l-1.38 9a2 2 0 002 2.3zm7-13h2.67A2.31 2.31 0 0122 4v7a2.31 2.31 0 01-2.33 2H17",
  key: "1mnleo"
}]]]);
export default ThumbsDown;